export enum KycStepStatus {

    NotPassed,
    InProgress,
    Completed,
    Skipped
}
